export default __webpack_public_path__ + "c6a4017766a764d33fff8eb3e498b08f.png";